export default __webpack_public_path__ + "static/media/x-icon.70e07c86.png";